<script lang="ts">
  import { Tween } from 'svelte/motion';
  import { cubicOut } from 'svelte/easing';

  let data = $state([
    { x: 10, y: 10, width: 5, height: 40 },
    { x: 10, y: 60, width: 5, height: 40 },
    { x: 10, y: 110, width: 5, height: 40 },
    { x: 10, y: 160, width: 5, height: 40 },
    { x: 10, y: 210, width: 5, height: 40 }
  ]);

  const position = (x: number, y: number) =>
    `transform: translate(${x}px, ${y}px)`;

  // This will update whenever data changes
  const widths = Tween.of(() => data.map((d) => d.width), {
    duration: 1000,
    easing: cubicOut
  });

  const handleClick = () => {
    data = [
      { x: 10, y: 10, width: 450 * Math.random(), height: 40 },
      { x: 10, y: 60, width: 320 * Math.random(), height: 40 },
      { x: 10, y: 110, width: 160 * Math.random(), height: 40 },
      { x: 10, y: 160, width: 80 * Math.random(), height: 40 },
      { x: 10, y: 210, width: 10 * Math.random(), height: 40 }
    ];
  };
</script>

<div>
  <svg viewBox="0 0 600 300">
    {#each data as d, i}
      <rect
        x={d.x}
        y={d.y}
        width={widths.current[i]}
        height={d.height}
        fill="white" />
      <text
        fill="white"
        style={position(d.x + widths.current[i] + 10, d.y + d.height / 2 + 5)}
        text-anchor="start">
        {widths.current[i].toFixed(0)}
      </text>
    {/each}
  </svg>
  <button
    onclick={handleClick}
    class="m-2 rounded-lg bg-yellow-400 px-2 py-2 text-lg font-semibold text-gray-900 hover:bg-yellow-500"
    >Animate</button>
</div>
